export default __webpack_public_path__ + "static/media/egg-result.29752106.png";